import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@narvar/nth-checkbox';
import TextInput from '@narvar/nth-text-input';
import SelectList from '@narvar/nth-select-list';
import Button, { primary } from '@narvar/nth-button';
import { COUNTRY_STATES } from '../../../../constants/geolocalization';

const inputSpacing = { margin: '1rem 0' };

const PickupLocationPanel = ({
  handleFormChange,
  showError,
  errorMessage,
  formData,
  submitForm,
  buttonText,
  buttonDisabled,
  isBusinessAddress,
  businessCheckboxLabel,
  provinceSelectorLabel,
  handleBusinessAddressChange,
}) => (
  <div>
    <Checkbox
      id="is-business-address"
      checked={isBusinessAddress}
      onChange={handleBusinessAddressChange}
    >
      <span>{businessCheckboxLabel}</span>
    </Checkbox>
    {isBusinessAddress && (
      <div style={inputSpacing}>
        <TextInput
          label="Company Name"
          defaultValue={formData.company_name}
          onChange={handleFormChange('company_name')}
        />
      </div>
    )}
    <div style={inputSpacing}>
      <TextInput
        label="Street Address*"
        defaultValue={formData.address_line1}
        onChange={handleFormChange('address_line1')}
      />
    </div>
    <div style={inputSpacing}>
      <TextInput
        label="Apt / Suite / Other"
        defaultValue={formData.address_line2}
        onChange={handleFormChange('address_line2')}
      />
    </div>
    <div style={inputSpacing}>
      <TextInput label="City*" defaultValue={formData.city} onChange={handleFormChange('city')} />
    </div>
    <SelectList onChange={handleFormChange('province')} value={formData.province}>
      <option disabled>{provinceSelectorLabel}</option>
      {COUNTRY_STATES.US.map(({ state_name: state }) => (
        <option>{state}</option>
      ))}
    </SelectList>
    <div style={inputSpacing}>
      <TextInput
        label="Zip"
        defaultValue={formData.postal_code}
        onChange={handleFormChange('postal_code')}
      />
    </div>
    {showError && (
      <p
        style={{
          margin: '1rem 0',
          color: '#E53935',
        }}
      >
        {errorMessage}
      </p>
    )}
    <Button
      big
      onClick={submitForm}
      disabled={buttonDisabled}
      s={primary({ disabled: buttonDisabled })}
    >
      {buttonText}
    </Button>
  </div>
);

PickupLocationPanel.defaultProps = {
  showError: false,
  errorMessage: 'Service is unavailable for this location.',
  businessCheckboxLabel: 'This is a business',
  provinceSelectorLabel: 'Select One:',
  buttonText: 'UPDATE ADDRESS',
  isBusinessAddress: false,
  buttonDisabled: false,
};

PickupLocationPanel.propTypes = {
  handleFormChange: PropTypes.func.isRequired,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string,
  formData: PropTypes.objectOf(PropTypes.string).isRequired,
  submitForm: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  businessCheckboxLabel: PropTypes.string,
  provinceSelectorLabel: PropTypes.string,
  isBusinessAddress: PropTypes.bool,
  handleBusinessAddressChange: PropTypes.func.isRequired,
};

export default PickupLocationPanel;
